module.exports = __webpack_public_path__ + "static/header-image-2346aa01187c0a10a15c084deb935a94.png";